<bb-form-element [form]="form" [label]="'THUMBNAIL_SETS' | translate">
	<bb-label-code-list 
		[codeProp]="'name'" [showActiveCheckbox]="true"	[extraColumns]="extraFieldsCodeListCropSets" 
		[(ngModel)]="internalValue" (ngModelChange)="update()" name="customThumbnailSets" [form]="form">
	</bb-label-code-list>
</bb-form-element>
